import React, {  } from "react";
import { ReactComponent } from "@formio/react";
import settingsForm from "./LabelCustom.settingsForm";
import { createRoot } from "react-dom/client";
import LabelCustomComponent from "./LabelCustomComponent"

export default class LabelComponent extends ReactComponent {
    static shouldSetValue = false;

    constructor(component, options, data) {
        options["oldState"] = {};
        super(component, options, data);
        this.reactInstance = null;
    }

    static schema(...extend) {
        return ReactComponent.schema({
            type: "labelCustomComponent",
            label: "label",
            persistent: false,
            key: `label_${new Date().getTime()}`,
        });
    }

    static get builderInfo() {
        return {
            title: "Label Custom",
            icon: "label",
            group: "Basic",
            documentation: "",
            weight: -10,
            schema: LabelComponent.schema(),
        };
    }

    static editForm = settingsForm;

    attachReact(element, ref) {
        const rootForm = this.getRoot(); // Get the root form object
        const root = createRoot(element); // Use createRoot to create a root for rendering

        root.render(
            <LabelCustomComponent
                component={this.component}
                options={this.component.options || []}
                onChange={this.updateValue}
                value={this.dataValue}
                data={this.data}
                form={rootForm}
                oldState={this.options["oldState"]}
                setComponentState={this.setComponentState}

            />
        );
    }

    setComponentState = (value) => {
        this.options["oldState"] = { ...value };
        this.updateOnChange({}, true);
    };


    detachReact(element) {
        return;
    }

    setValue(value) {
        if (this.reactInstance) {
            this.reactInstance.setState({
                value: value,
            });
            this.shouldSetValue = false;
        } else {
            this.shouldSetValue = true;
            this.dataForSetting = value;
        }
    }

    checkValidity(data, dirty, rowData) {
        const valid = super.checkValidity(data, dirty, rowData);
        if (!valid) {
            return false;
        }
        return this.validate(data, dirty, rowData);
    }

    validate(data, dirty, rowData) {
        return true;
    }
}
